import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "Serverless file upload to S3 with NextJS and AWS Lambda – CodeWithSwiz 27",
  "description": "The Girl loves her daily cute photos, but she's bored of repeats. What if adding images was easier 🤔",
  "published": "2021-04-20T00:00:00.000Z",
  "categories": "Livecoding, CodeWithSwiz, Serverless",
  "content_upgrade": "ServerlessHandbook",
  "hero": "./img/screenshot-1619281955100.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The Girl loves her daily cute photos, but she's bored of repeats. What if adding images was easier 🤔`}</p>
    <p>{`And now it is!`}</p>
    <p><img parentName="p" {...{
        "src": "/d73dabaa98dadc4617cb652f40744c61/kUItXrgif543bff.gif",
        "alt": null
      }}></img></p>
    <p>{`👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lovebox-uploader"
      }}>{`full UI code`}</a>{`
👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lovebox-lambda/blob/main/src/presignedUrl.ts"
      }}>{`full AWS code`}</a></p>
    <p>{`full build video 👇`}</p>
    <lite-youtube {...{
      "videoid": "dD2ni3_lAfo",
      "videostartat": "0"
    }}></lite-youtube>
    <ContentUpgrades.ServerlessHandbook />
    <h2 {...{
      "id": "the-outline"
    }}>{`The outline`}</h2>
    <p>{`We've got a lovebox lambda that `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/send-daily-random-photos-from-an-s3-bucket-using-aws-lambda-codewithswiz-25"
      }}>{`sends daily random photos from an S3 bucket`}</a>{` to an IoT device on my girlfriend's desk. Plastic heart spins, girl opens box, girl sees pic, girl smiles. Swiz gets best boyfriend points.`}</p>
    <p>{`Works great except I never added more than 5 photos. Uploading to S3 is a pain in the ass 😅`}</p>
    <p>{`Here's how we're gonna fix that:`}</p>
    <ul>
      <li parentName="ul">{`web UI collects images to upload`}</li>
      <li parentName="ul">{`fetches a pre-signed S3 upload URL`}</li>
      <li parentName="ul">{`uploads image`}</li>
      <li parentName="ul">{`repeat until all images uploaded`}</li>
    </ul>
    <p>{`Amazon S3 uses pre-signed URLs to make file uploads secure. Each URL is good for 1 upload. Specific file type, expires fast, pre-defined file name.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3ff19ed4cc23c886b87d2ad7339538ca/07d37/Sketch-of-the-process4h5b8i.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.04932735426009%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'172\\'%20viewBox=\\'0%200%20400%20172\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M98%205l-3%201v72c-1%203-1%203-7%202a139%20139%200%2000-61%209l7-2c17-5%2037-8%2050-7%2011%201%2011%200%209%2021-2%2020-2%2034-1%2036h15a586%20586%200%2001108-5l2-1%202-1-2-1-3-3%201-15a366%20366%200%200113%202l-12-4v-5c0-9%201-13%203-13l3-1-2-1c-4%200-3-3%202-5l3-3-4%201-3%202%201-6v-7l18-10c25-15%2040-22%2029-15l-3%204c1%201%2012-8%2012-10%200-1-6-1-11%201-2%200-3%202-1%202l-7%205-22%2013-13%208-1-4%201-18%201-27c0-11%201-12%202-13%202-1%202-1%201-2H98m2%201l-4%201v38a474%20474%200%2001-3%2080v11h4l10-1c15-2%2050-4%2076-5%2033%200%2030%201%2030-10v-10l-7-3-7-4%206%202c8%204%208%205%2010-8%200-6%200-6-2-5-4%201-5-1-3-4l2-2c0%201%204%200%204-3v-1h-2l1-1c2-1%203-8%202-8l-5%203-5%201%205-4c5-2%206-3%206-5a397%20397%200%20013-45l1-17H100m184%209l-4%203c-3%202-1%203%203%200%204-2%206-1%207%204s1%205-8%2010l-5%204c-2%202%200%204%201%202l6-4%205-4%202-2%203%206%204%206-3-9-4-11c0-5-2-6-7-5M169%2030l-8%202-5%203c-3%201-3%201-5-1-2-3-3-3-8%200-4%202-4%202-7%201-4-2-6-2-8%200s-1%203%201%202h5c3%203%207%203%2010%201h6c3%201%204%201%207-1l22-7v3c0%202%201%203%205%201%202-1%203-1%205%201s5%203%205%202l-3-4c-2-2-3-2-6-1-3%200-4%200-4-2%201-2-7-3-12%200m-50%2020c-2%202-8%2012-8%2016-1%204%200%204%2010%203l11-2c4%200%204%200%206-4%204-10%201-14-10-14l-9%201m-1%204l-6%2013h4l12-1h7l2-6c3-7%202-9-9-9-8%200-8%200-10%203m44%2028a2409%202409%200%2001-38%204c0%204-1%205-4%203-6-4-8-2-3%201l5%203-3%201c-2%201-2%201%200%201s2%201%200%207l1%202%202-3c0-5%203-9%203-3l1%202%201-1%202-2h3l-3-1c-3%200-2-3%201-2v-1h-3c-2%201-2%201-2-2l1-4c1-1%2039-4%2057-4h14l-2%202c-2%203-4%2011-5%2020l-1%204-6-1-15-1a1038%201038%200%2001-17%202%201267%201267%200%200140-1c0-7%204-21%206-22%201-2%201-4-1-4h-34m122%2026c-7%203-8%203-10%2016-2%2011-3%2020-1%2015l1-6c0-4%200-4%202-4%207%203%2027%202%2027%200h-4c-3%201-18%201-21-1-3%200-3-3-2-8l3-5c4%202%2014%203%2021%203h9a522%20522%200%20011-9c-3-3-18-4-26-1m3%201c-10%202-11%204-4%206%2018%204%2033%201%2026-5-2-2-16-3-22-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3ff19ed4cc23c886b87d2ad7339538ca/ca0a1/Sketch-of-the-process4h5b8i.webp 223w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/75680/Sketch-of-the-process4h5b8i.webp 445w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/8d1ba/Sketch-of-the-process4h5b8i.webp 890w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/3838e/Sketch-of-the-process4h5b8i.webp 1335w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/e11e5/Sketch-of-the-process4h5b8i.webp 1780w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/0ddd7/Sketch-of-the-process4h5b8i.webp 1790w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3ff19ed4cc23c886b87d2ad7339538ca/e92b6/Sketch-of-the-process4h5b8i.png 223w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/e66bf/Sketch-of-the-process4h5b8i.png 445w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/4ef49/Sketch-of-the-process4h5b8i.png 890w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/4e814/Sketch-of-the-process4h5b8i.png 1335w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/701e9/Sketch-of-the-process4h5b8i.png 1780w", "/static/3ff19ed4cc23c886b87d2ad7339538ca/07d37/Sketch-of-the-process4h5b8i.png 1790w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3ff19ed4cc23c886b87d2ad7339538ca/4ef49/Sketch-of-the-process4h5b8i.png",
                "alt": "Sketch of the process",
                "title": "Sketch of the process",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Sketch of the process`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "the-aws-lambda"
    }}>{`The AWS Lambda`}</h2>
    <p>{`The Lambda that generates a new pre-signed URL follows the REST API pattern. GraphQL would be overkill because we're fetching 1 value.`}</p>
    <p>{`We add it in `}<inlineCode parentName="p">{`serverless.yml`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`# serverless.yml
functions:
  # ...

  presignedUrl:
    handler: dist/presignedUrl.getUrl
    events:
      - http:
          path: presignedurl
          method: GET
          cors: true
`}</code></pre>
    <p><inlineCode parentName="p">{`presignedUrl`}</inlineCode>{` calls the `}<inlineCode parentName="p">{`getUrl`}</inlineCode>{` method when you hit the `}<inlineCode parentName="p">{`/presignedurl`}</inlineCode>{` path with a GET request.`}</p>
    <h3 {...{
      "id": "prep-params"
    }}>{`Prep params`}</h3>
    <p>{`The method itself starts by prepping params for the S3 API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/presignedUrl.ts

export async function getUrl(event: APIGatewayEvent) {
    const fileType = event.queryStringParameters?.filetype;

    // verify file type was passed
    if (!fileType?.startsWith("image")) {
        return {
            statusCode: 400,
            body: JSON.stringify({ error: "Please upload an image" }),
        };
    }

    // image/png -> png
    const extension = fileType.split("/")[1];

    const imageId = uuidv4();
    const filename = \`\${imageId}.\${extension}\`;
    const expireSeconds = 60 * 5;
    const readUrl = \`https://lovebox-stash.s3.amazonaws.com/\${filename}\`;
`}</code></pre>
    <p>{`We grab the `}<inlineCode parentName="p">{`filetype`}</inlineCode>{` param from the querystring and verify it exists. We'll need it to generate the file name and tell S3 what type of file to expect.`}</p>
    <p>{`Then we generate a new UUID for the image name, define a 5min expiration, and create a URL our client can use to display the image after upload.`}</p>
    <h3 {...{
      "id": "generate-upload-url"
    }}>{`Generate upload URL`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/presignedUrl.ts

export async function getUrl(event: APIGatewayEvent) {
  // ...

  const uploadUrl = s3.getSignedUrl("putObject", {
    Bucket: "lovebox-stash",
    Key: filename,
    ContentType: fileType,
    Expires: expireSeconds,
  })

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "access-control-allow-methods": "GET",
  }

  return {
    statusCode: 200,
    headers,
    body: JSON.stringify({
      uploadUrl,
      readUrl,
      imageId,
    }),
  }
}
`}</code></pre>
    <p>{`When everything's ready, we call `}<inlineCode parentName="p">{`s3.getSignedUrl`}</inlineCode>{` to create a new upload URL. It works for 5 minutes on our exact upload. Once used, it's done.`}</p>
    <p>{`We return a bunch of CORS headers to make this callable from the browser and add the generated url.`}</p>
    <p>{`You get an API response like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "uploadUrl": "https://lovebox-stash.s3.amazonaws.com/6b27de0f-f719-4792-a8ec-f4c26a0f5d7d.png?AWSAccessKeyId=ASIAVGA6PM7APGWCNIXD&Content-Type=image%2Fpng&Expires=1618934335&Signature=PgBtnH%2BJ6QswFHY4vCvQ0wJOWuE%3D&x-amz-security-token=IQoJb3JpZ2luX2VjECgaCXVzLWVhc3QtMSJHMEUCIGpLnl1QR0avgrz%2BCch8H0Sr%2FTIHNEbUSU3BOQICAQQkAiEAxiFrEwKvv6vq%2BLNYTFzylSP6YqqOQWaLr0Y2uvsYOowq5wEIkf%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwzNTY1NDYyMDk3MjgiDHp3IQG1N95uWNEVjiq7AQ3fYHQkBvv%2BeqPM7sK0AM437xIXgOHFqhRW7u1JDhzKr363EPyjN1xaErhBIso058PtjpGTGN2mBUKWysaVvJGPBfCriUls1upJ%2BM9MgNeYuEhIyU%2BBmrAEq91M4WwH%2BjW%2FIZKrAJfeiU8kAjJVMdJSD2GCEDUVUTFgTgoEMYFrGQxidJbvTR3mg6eLajbENuwqb7g7guePhFKs1AqzI%2FLAaZxAfj2ToGslFE17GaagvEadGDw2XWl%2Ff10wkvL7gwY64AGfSFcLkWZlOP2MyHflJaCPhsFP2%2BZCEPtiE5CSlkmGYWIC7CbQcKj0bhIUXHOBzH%2BvV1JGVzfKXLRbU7WXEvYWk5SqfT%2FrAxphDTEYoP28RD10BWU2o8JEH%2FWG6YINVeVFCAl%2FuviyL3ysDhB%2FjMX6Vpjte1pdUmsmmMode%2FeExDCZtp5hTsUnLFbMFgloldnvYadaERN5gYZlC9sEtsKhacsaUkwUPDVtQJv7XPj0Zkf6hFVfKH0cgOCGFhy%2BUoBDZ2r0%2B3Xh%2Bs1oSnTOMlXn8eIzVeMPQRHB%2BEmF3J6nug%3D%3D",
  "readUrl": "https://lovebox-stash.s3.amazonaws.com/6b27de0f-f719-4792-a8ec-f4c26a0f5d7d.png",
  "imageId": "6b27de0f-f719-4792-a8ec-f4c26a0f5d7d"
}
`}</code></pre>
    <p>{`The file is private so maybe the `}<inlineCode parentName="p">{`readUrl`}</inlineCode>{` isn't useful 🤔`}</p>
    <h2 {...{
      "id": "the-nextjs-ui"
    }}>{`The NextJS UI`}</h2>
    <p>{`NextJS made it quick to spin up a new React app.`}</p>
    <p>{`I was hoping to leverage server-side-generation to fetch the upload URL, but the UX wasn't great. You need a new URL for every file to enable multi-file upload and the upload works better when you know the file type.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/3ornjSL2sBcPflIDiU/giphy-loop.mp4?cid=7cf28b0f5g2rnmranyj5sgkw4gmm3wqvxqz8dxze4np246p7&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`We cleaned out the default homepage and added a `}<inlineCode parentName="p">{`<LoveboxDropzone />`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// pages/index.js

export default function Home() {
    return (
        <div className={styles.container}>

            <main className={styles.main}>
                <h1 className={styles.title}>Lovebox Stash ❤️</h1>

                <p className={styles.description}>
                    Add cute photos to your Lovebox stash for The Girl
                </p>

                <LoveboxDropzone />
            </main>
`}</code></pre>
    <p><inlineCode parentName="p">{`LoveboxDropzone`}</inlineCode>{` handles the upload UI and logic.`}</p>
    <h3 {...{
      "id": "loveboxdropzone"
    }}>{`LoveboxDropzone`}</h3>
    <p>{`We used `}<a parentName="p" {...{
        "href": "https://react-dropzone.js.org/"
      }}>{`react-dropzone`}</a>{` to handle the intricacies of file uploads and drag-n-drop. Works great 👌`}</p>
    <p>{`Copied the core code from docs:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// components/LoveboxDropzone.js

export function LoveboxDropzone() {
  const onDrop = useCallback(async (acceptedFiles) => {
    // handle file upload
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  })

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Drop your photos here ...</p>
      ) : (
        <p>Drag'n'drop photos here, or click to select files</p>
      )}
    </div>
  )
}
`}</code></pre>
    <p>{`react-dropzone gives you a `}<inlineCode parentName="p">{`useDropzone`}</inlineCode>{` hook that returns the props you need to render. You give it a callback to handle files.`}</p>
    <p>{`Ours looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const onDrop = useCallback(async (acceptedFiles) => {
  setUploading(true)

  await Promise.all(acceptedFiles.map(uploadFile))

  setUploading(false)
}, [])
`}</code></pre>
    <p><inlineCode parentName="p">{`useCallback`}</inlineCode>{` ensures a stable function reference – avoids re-renders. `}<inlineCode parentName="p">{`setUploading(true/false)`}</inlineCode>{` shows a spinner from `}<inlineCode parentName="p">{`react-spinner`}</inlineCode>{` so users know an upload is in progress.`}</p>
    <p><inlineCode parentName="p">{`await Promise.all`}</inlineCode>{` runs each file upload in parallel and waits for them all to finish. Makes the UX faster when you upload a bunch 😊`}</p>
    <h3 {...{
      "id": "the-file-upload"
    }}>{`The file upload`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`uploadFile`}</inlineCode>{` function handles each individual file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// components/LoveboxDropzone.js

async function uploadFile(file) {
  const [{ uploadUrl }, data] = await Promise.all([
    getPresignedUploadUrl(file),
    readFile(file),
  ])

  const res = await fetch(uploadUrl, {
    method: "PUT",
    body: data,
    headers: {
      // file type has to match presigned url type
      "Content-Type": file.type,
    },
  })

  if (res.ok) {
    console.log(await res.text())
  } else {
    console.log("ERROR")
    console.log(res)
  }
}
`}</code></pre>
    <p>{`Uploads happen in 3 stages:`}</p>
    <ol>
      <li parentName="ol">{`Fetch the pre-signed upload url`}</li>
      <li parentName="ol">{`Read file as a binary blob`}</li>
      <li parentName="ol">{`Upload to S3 via upload url`}</li>
    </ol>
    <p>{`We do 1 and 2 in parallel with `}<inlineCode parentName="p">{`Promise.all`}</inlineCode>{` to improve UX.`}</p>
    <p>{`You'll notice there's no error handling. If something goes wrong, the user will never know. Spinner spins forever.`}</p>
    <p>{`That's okay for a quick hack. ✌️`}</p>
    <h3 {...{
      "id": "fetch-pre-signed-upload-url"
    }}>{`fetch pre-signed upload url`}</h3>
    <p>{`We've got an AWS Lambda that works as a REST API and generates upload urls on demand. We can use a `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` request. No need to get fancy.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`async function getPresignedUploadUrl(file) {
  const presignedUrl = await fetch(\`\${URL}?filetype=\${file.type}\`).then((res) =>
    res.json()
  )

  return presignedUrl
}
`}</code></pre>
    <p>{`Lambda `}<inlineCode parentName="p">{`URL`}</inlineCode>{` is a constant (should be an ENV var), add `}<inlineCode parentName="p">{`filetype`}</inlineCode>{` to query params, fetch. Parsing `}<inlineCode parentName="p">{`json()`}</inlineCode>{` throws an error if the request fails. That's good enough.`}</p>
    <p>{`Using React Query would be overkill because we don't need a caching layer. Each response only works once.`}</p>
    <h3 {...{
      "id": "read-file-as-a-binary-blob"
    }}>{`read file as a binary blob`}</h3>
    <p>{`Modern browsers offer a full-on file API. You have `}<inlineCode parentName="p">{`File`}</inlineCode>{` objects with meta data and you can read their contents into memory with the `}<inlineCode parentName="p">{`FileReader`}</inlineCode>{`.`}</p>
    <p>{`A lot like a filesystem except it runs in memory.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`async function readFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onabort = () => reject()
    reader.onerror = () => reject()
    reader.onload = () => resolve(reader.result)

    reader.readAsArrayBuffer(file)
  })
}
`}</code></pre>
    <p>{`Unfortunately the `}<inlineCode parentName="p">{`FileReader`}</inlineCode>{` API predates promises. We tack a custom promise on top of its event-based interface.`}</p>
    <p><inlineCode parentName="p">{`onload`}</inlineCode>{` resolves the promise with data, `}<inlineCode parentName="p">{`onabort`}</inlineCode>{` and `}<inlineCode parentName="p">{`onerror`}</inlineCode>{` reject. In async/await land this translates to a returned value and errors.`}</p>
    <h3 {...{
      "id": "upload-to-s3-via-upload-url"
    }}>{`upload to S3 via upload url`}</h3>
    <p>{`The final upload is another `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` call. React Query would again be overkill because we're making unique requests.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const res = await fetch(uploadUrl, {
  method: "PUT",
  body: data,
  headers: {
    // file type has to match presigned url type
    "Content-Type": file.type,
  },
})
`}</code></pre>
    <p>{`Make a `}<inlineCode parentName="p">{`PUT`}</inlineCode>{` request to the `}<inlineCode parentName="p">{`uploadUrl`}</inlineCode>{`, push file data into the body, set `}<inlineCode parentName="p">{`Content-Type`}</inlineCode>{` to the file type.`}</p>
    <h2 {...{
      "id": "and-it-works-"
    }}>{`And it works 🎉`}</h2>
    <p>{`Works like a charm. Uploaded 12 images at once from my phone 🤘`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Works great on mobile which is exactly what I needed 👉 a quick way to add photos on the go.`}<br parentName="p"></br><br parentName="p"></br>{`Multiple file upload do smooth 👌 `}<a parentName="p" {...{
          "href": "https://t.co/tGufnF8uCl"
        }}>{`pic.twitter.com/tGufnF8uCl`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1384527910397124610"
      }}>{`April 20, 2021`}</a></blockquote>
    <p>{`Time to go make some memories.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: you can learn more about serverless in general from `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`Serverless Handbook`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      